export default __webpack_public_path__ + "static/media/boite8.e6b0e3d9.jpg";